import { IOMConfig } from '@models/Log';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import AdminLogApi from 'apis/api/AdminLog';
import AuthServiceApi from 'apis/api/Auth';
import ProductTransactionApi from 'apis/api/ProductTransaction';

export const getAllOMConfig = createAsyncThunk('adminConfig/getAllOMConfig', async () => {
  const response = await AdminLogApi.GetAllConfig();
  return response.data;
});

export const getAllUser = createAsyncThunk('adminConfig/getAllUser', async () => {
  const response = await AuthServiceApi.GetAllUserV2();
  return response.data;
});

export const getAllUserOperating = createAsyncThunk('adminConfig/GetListUserByRoleV2', async (roleName: any) => {
  const response = await AuthServiceApi.GetListUserByRoleV2(roleName);
  return response.data;
});

export const getAllUserSales = createAsyncThunk('adminConfig/getAllUserSales', async () => {
  const response = await AuthServiceApi.GetAllUserSales();
  return response.data;
});

export const getTypeAndState = createAsyncThunk('adminConfig/getTypeAndState', async () => {
  const response = await ProductTransactionApi.GetTypeAndState();
  return response.data;
});

export const getStateTech = createAsyncThunk('adminConfig/getStateTech', async () => {
  const response = await ProductTransactionApi.GetStateTech();
  return response.data;
});

export const getAllUserAccountant = createAsyncThunk('adminConfig/GetListAccountantByRoleV2', async (roleName: any) => {
  const response = await AuthServiceApi.GetListUserByRoleV2(roleName);
  return response.data;
});

export const getMenuUserAccess = createAsyncThunk('adminConfig/getMenuUserAccess', async (keys: string[]) => {
  const entries = await Promise.all(
    keys.map(async key => {
      try {
        const res = await AdminLogApi.GetConfigWithKey(key);
        const raw: string = !res.data.error ? res.data.data?.data ?? '' : '';
        return [
          key,
          raw
            .split(',')
            .map(s => s.trim())
            .filter(Boolean)
        ] as const;
      } catch {
        return [key, [] as string[]] as const;
      }
    })
  );
  return Object.fromEntries(entries) as Record<string, string[]>;
});

interface ISelectLoadedData {
  OMConfigLoaded?: boolean | null;
  AllUserLoaded?: boolean | null;
  AllUserOperatingLoaded?: boolean | null;
  AllUserSalesLoaded?: boolean | null;
  AllUserAccountantsLoaded?: boolean | null;
  walletListLoaded?: boolean | null;
  walletTechListLoaded?: boolean | null;
  menuUserAccessLoaded?: boolean | null;
}

type initialStateType = {
  loadedData: ISelectLoadedData;
  configOM: Array<IOMConfig>;
  allUser: any[];
  allUserOperating: any[];
  allUserAccountant: any[];
  walletListType: any[];
  walletListState: any[];
  walletListStateTech: any[];
  allUserSales: any[];
  menuUserAccess: Record<string, string[]>;
};
const initialState: initialStateType = {
  configOM: [],
  allUser: [],
  allUserOperating: [],
  allUserAccountant: [],
  walletListType: [],
  walletListState: [],
  walletListStateTech: [],
  allUserSales: [],
  menuUserAccess: {},
  loadedData: {
    OMConfigLoaded: null,
    AllUserLoaded: null,
    AllUserOperatingLoaded: null,
    AllUserSalesLoaded: null,
    AllUserAccountantsLoaded: null,
    walletListLoaded: null,
    walletTechListLoaded: null,
    menuUserAccessLoaded: null
  }
};
const adminConfig = createSlice({
  name: 'adminConfig',
  initialState: initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getMenuUserAccess.fulfilled, (state, action) => {
      state.menuUserAccess = action.payload || {};
      state.loadedData.menuUserAccessLoaded = true;
    });
    builder.addCase(getAllOMConfig.fulfilled, (state, action) => {
      // console.log('addCase getAllOMConfig', action.payload?.data);
      state.loadedData.OMConfigLoaded = true; // đã load chi nhánh đầu
      state.configOM = action.payload?.data || [];
    });
    builder.addCase(getAllUser.fulfilled, (state, action) => {
      // console.log('addCase getAllUser11', action.payload?.data);
      state.loadedData.AllUserLoaded = true; // đã load chi nhánh đầu
      state.allUser = action.payload?.data || [];
    });

    builder.addCase(getAllUserOperating.fulfilled, (state, action) => {
      // console.log('addCase getAllUserOperating', action.payload?.data);
      state.loadedData.AllUserOperatingLoaded = true; // đã load chi nhánh đầu
      state.allUserOperating = action.payload?.data || [];
    });

    builder.addCase(getAllUserSales.fulfilled, (state, action) => {
      // console.log('addCase getAllUserSales', action.payload?.data);
      state.loadedData.AllUserSalesLoaded = true; // đã load chi nhánh đầu
      state.allUserSales = action.payload?.data || [];
    });

    builder.addCase(getAllUserAccountant.fulfilled, (state, action) => {
      // console.log('addCase getAllUserAccountant', action.payload?.data);
      state.loadedData.AllUserAccountantsLoaded = true; // đã load chi nhánh đầu
      state.allUserAccountant = action.payload?.data || [];
    });

    builder.addCase(getTypeAndState.fulfilled, (state, action) => {
      // console.log('addCase getTypeAndState', action.payload);
      // state.usersTechnician = action.payload?.data || [];
      state.walletListState = action.payload?.data?.states || [];
      state.walletListType = action.payload?.data?.types || [];
      state.loadedData.walletListLoaded = true;
    });

    builder.addCase(getStateTech.fulfilled, (state, action) => {
      // console.log('addCase getStateTech', action.payload);
      // Lấy states ra, nếu không có thì mặc định là một object rỗng
      const statesObj = action.payload?.data?.states || {};
      // Bóc tách 'Used' ra riêng, phần còn lại gom vào biến 'remainingStates'
      const { ...remainingStates } = statesObj;
      // Lưu object đã lọc vào Redux state
      state.walletListStateTech = remainingStates;
      state.loadedData.walletTechListLoaded = true;
    });
  }
});

export default adminConfig.reducer;
